export default
    {
        // url: this.$store.state.http.catalogos.YYYY,
        incidencias:"/catalogos/incidencias",
        areas:"/catalogos/areas",
        servicios: "/catalogos/servicios",
        catalogoCasfCuentas:"/catalogos/catalogoCasfCuentas",
        catalogoLocalidades: "/catalogos/dgisLocalidades",
        catalogoMunicipios: "/catalogos/municipios",
        profesiones: "/catalogos/profesiones",
        derechohabiencias:"/catalogos/derechohabiencias",
        religiones:"/catalogos/religiones",
        catalogoAreasEnfermeria:"/catalogos/catalogoAreasEnfermeria",
    }
